<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content [formGroup]="efForm" autocomplete="off">
  <mat-form-field class="full">
    <mat-label>Name</mat-label>
    <input type="text" matInput formControlName="name" [errorStateMatcher]="matcher" id="ef-name" [maxlength]="EMISSION_FACTOR_NAME_MAX" placeholder="For example Diesel or Grid electricity" required>
    <mat-hint align="end">{{efForm.value.name?.length || 0}}/{{EMISSION_FACTOR_NAME_MAX}}</mat-hint>
    @if (efForm.controls['name'].hasError('required')) {
      <mat-error>Name is <strong>required</strong></mat-error>
    }@else if (efForm.controls['name'].hasError('duplicate')) {
      <mat-error>There is already an emission factor with this name</mat-error>
    }@else if (efForm.controls['name'].invalid) {
      <mat-error>{{getNameError()}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="full">
    <mat-label>Description</mat-label>
    <input type="text" matInput formControlName="description" [errorStateMatcher]="matcher" id="ef-description" [maxlength]="EMISSION_FACTOR_DESCRIPTION_MAX" placeholder="Where the factor comes from, such as a government source and year">
    <mat-hint align="end">{{efForm.value.description?.length || 0}}/{{EMISSION_FACTOR_DESCRIPTION_MAX}}</mat-hint>
    @if (efForm.controls['description'].hasError('maxlength')) {
      <mat-error>{{getDescriptionError()}}</mat-error>
    }
  </mat-form-field>

  <div class="row">
    <mat-form-field>
      <mat-label>Scope</mat-label>
      <mat-select formControlName="scope" [errorStateMatcher]="matcher" (selectionChange)="scopeSelected()" required>
        @for (scope of scopes; track scope) {
          <mat-option [value]="scope">{{scope}} &ndash; {{getScopeShortDescription(scope)}}</mat-option>
        }
      </mat-select>
      @if (efForm.controls['scope'].invalid) {
        <mat-error>Choose a scope from the list</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select formControlName="type" [errorStateMatcher]="matcher" (selectionChange)="typeSelected()" required>
        @for (type of types; track type) {
          <mat-option [value]="type">{{getTypeName(type)}}</mat-option>
        }
      </mat-select>
      @if (efForm.controls['type'].invalid) {
        <mat-error>Choose a type from the list</mat-error>
      }
    </mat-form-field>
  </div>
  @if (scopeDescription || efForm.value.type) {
    <div class="explain">
      @if (scopeDescription) { <p><strong>{{efForm.value.scope}}:</strong> {{scopeDescription}}</p> }
      @if (efForm.controls['type'].value) { <p><strong>{{getTypeName(efForm.controls['type'].value)}}:</strong> {{getHint()}}</p> }
    </div>
  }
  @if (getTypeChangeWarning()) {
    <p class="warning">{{getTypeChangeWarning()}}</p>
  }

  @if (energyTypeSelected) {
    <p class="section-hint">The factor is worked out from the fuel's density, energy density and emissions per MJ.</p>
    <div class="row three">
      <mat-form-field>
        <mat-label>Density (kg/l)</mat-label>
        <input type="number" min="0" matInput formControlName="density" id="ef-density">
        @if (efForm.controls['density'].invalid) {
          <mat-error>Enter a value above 0</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Energy density (MJ/kg)</mat-label>
        <input type="number" min="0" matInput formControlName="energyDensity" id="ef-energyDensity">
        @if (efForm.controls['energyDensity'].invalid) {
          <mat-error>Enter a value above 0</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Emissions (kg CO&#8322;e/MJ)</mat-label>
        <input type="number" min="0" matInput formControlName="energyFactor" id="ef-energyFactor">
        @if (efForm.controls['energyFactor'].invalid) {
          <mat-error>Enter a value above 0</mat-error>
        }
      </mat-form-field>
    </div>
  }

  <mat-form-field class="value-field">
    <mat-label>Emission factor</mat-label>
    <input type="number" min="0" matInput formControlName="value" [errorStateMatcher]="matcher" id="ef-value" required>
    <span matTextSuffix>kg CO&#8322;e{{units ? ' per ' + units : ''}}</span>
    @if (energyTypeSelected) {
      <mat-hint>Worked out from the values above</mat-hint>
    }
    @if (efForm.controls['value'].hasError('required')) {
      <mat-error>Emission factor is <strong>required</strong></mat-error>
    }@else if (efForm.controls['value'].invalid) {
      <mat-error>{{getValueError()}}</mat-error>
    }
  </mat-form-field>

  @if (saveProblem) {
    <p class="warning">{{saveProblem}}</p>
  }
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="accent" cdkFocusInitial (click)="save()">{{isNew ? 'Create' : 'Save'}}</button>
</div>
